(function() {
  'use strict';

 function createThumbnail(url) {
    var img = document.createElement('img');
    img.src = url;
    img.alt = 'Preview';
    img.style.cssText = 'width:72px;height:72px;object-fit:cover;display:block;border-radius:6px;cursor:pointer;border:1px solid #e0e0e0;';

    var link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.style.display = 'inline-block';
    link.onclick = function (e) {
      e.preventDefault();
      window.open(url, 'preview', 'toolbar=0,location=0,menubar=0,width=1000,height=800');
    };
    link.appendChild(img);
    return link;
  }


  function fixPreviewImages() {
    try {
      var elements = document.querySelectorAll('li, span, div');
      
      for (var i = 0; i < elements.length; i++) {
        var el = elements[i];
        if (el.dataset && el.dataset.previewFixed) continue;
        
        var text = el.textContent || '';
        if (!text.includes('Preview image:')) continue;
        
        var match = text.match(/Preview image:\s*(https?:\/\/[^\s]+)/);
        if (!match) continue;
        
        var url = match[1];
        var fixedUrl = url.replace('/temp/', '/screenshots/');
        
        if (el.dataset) el.dataset.previewFixed = 'true';
        
        var thumbnail = createThumbnail(fixedUrl);
        
        var parentLi = el.closest('li');
        if (parentLi) {
          parentLi.innerHTML = '';
          parentLi.appendChild(thumbnail);
        } else {
          el.innerHTML = '';
          el.appendChild(thumbnail);
        }
      }
    } catch(e) {}
  }

  

  function fixRebuyProperties() {
    var props = document.querySelectorAll(
      '.rebuy-cart__flyout-item-property.property-key-preview-image'
    );
    props.forEach(function (prop) {
      if (prop.dataset.previewFixed) return;

      var valSpan = prop.querySelector('.rebuy-cart__flyout-item-property-value');
      if (!valSpan) return;

      var url = valSpan.textContent.trim();
      if (!url.startsWith('http')) return;

      prop.dataset.previewFixed = 'true';

      // Reemplaza TODO el contenido del div de propiedad con el thumbnail
      prop.innerHTML = '';
      prop.style.cssText = 'margin:6px 0 4px;';
      prop.appendChild(createThumbnail(url));
    });
  }
  function run() {
    fixPreviewImages();
    fixRebuyProperties();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function() {
    run();
  });
  
  setTimeout(function() {
    observer.observe(document.body, { childList: true, subtree: true });
  }, 500);
})();